import React from "react";
import { formatFoot, formatHeight } from "../../utils/tenderFormatters";
import { formatMarketValue, formatMaxTransferFee } from "../../utils/searchRequestFormat";

// The extended-spec requirements a club can attach to a search request (DoD
// 20/21): preferred foot, minimum height, target market value, and the transfer
// budget (a max fee, or free-agents-only). Only filled rows render — an empty
// spec produces nothing. Shared by the club detail and the agent inbox so the
// agent sees exactly what the club asked for.
const Row = ({ label, value }) =>
  value ? (
    <div className="flex items-center justify-between gap-3 py-1.5">
      <span className="text-[12px] text-gray-500">{label}</span>
      <span className="text-[12.5px] font-semibold text-[#111827] text-right">{value}</span>
    </div>
  ) : null;

const SpecRequirements = ({ request, className = "" }) => {
  const isStaff = request.tender_category === "staff" || !!request.staff_role;
  const foot = formatFoot(request.foot);
  const height = formatHeight(request.minimum_height);
  const marketValue = formatMarketValue(request);
  const fee = request.only_free_players ? "Free agents only" : formatMaxTransferFee(request);

  const rows = [
    // Staff requests lead with the role (DoD 30); player-only attributes (foot,
    // height, market value) simply stay empty for staff and don't render.
    isStaff ? ["Role", request.staff_role_display] : null,
    !isStaff ? ["Preferred foot", foot] : null,
    !isStaff ? ["Minimum height", height] : null,
    !isStaff ? ["Market value", marketValue] : null,
    ["Transfer budget", fee],
  ].filter((r) => r && r[1]);

  if (rows.length === 0) return null;

  return (
    <div className={`flex flex-col ${className}`}>
      <span className="text-[11px] font-semibold uppercase tracking-wide text-gray-400 mb-1">
        Requirements
      </span>
      <div className="divide-y divide-[#F3F4F6]">
        {rows.map(([label, value]) => (
          <Row key={label} label={label} value={value} />
        ))}
      </div>
    </div>
  );
};

export default SpecRequirements;
